export function camelCaseToSentenceCase(camelCase: string) {
	return camelCase
		.replace(/([A-Z])/g, ' $1')
		.toLowerCase()
		.replace(/^./, (str) => str.toUpperCase())
		.trim();
}

export function pascalCaseToSentenceCase(pascalCase: string) {
	const lower = pascalCase.toLowerCase();
	const cased = lower.charAt(0).toUpperCase() + lower.slice(1);
	const spaced = cased.replace(/_/g, ' ');

	return spaced;
}

export function kebabCaseToSentenceCase(kebabCase: string) {
	return kebabCase
		.replace(/-/g, ' ')
		.toLowerCase()
		.replace(/^./, (str) => str.toUpperCase())
		.trim();
}
